import api from './api';
import { Mitarbeiter, MitarbeiterCreate, MitarbeiterUpdate, MitarbeiterList, MitarbeiterOeffentlichesProfil } from '../types';

export const mitarbeiterService = {
  list: async (params?: { aktiv?: boolean; rolle?: string }): Promise<MitarbeiterList[]> => {
    const response = await api.get('/mitarbeiter/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Mitarbeiter> => {
    const response = await api.get(`/mitarbeiter/${id}`);
    return response.data;
  },

  getOeffentlichesProfil: async (id: number): Promise<MitarbeiterOeffentlichesProfil> => {
    const response = await api.get(`/mitarbeiter/${id}/profil-oeffentlich`);
    return response.data;
  },

  create: async (data: MitarbeiterCreate): Promise<Mitarbeiter> => {
    const response = await api.post('/mitarbeiter/', data);
    return response.data;
  },

  update: async (id: number, data: MitarbeiterUpdate): Promise<Mitarbeiter> => {
    const response = await api.put(`/mitarbeiter/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/mitarbeiter/${id}`);
  },

  reset2FA: async (id: number) => {
    const response = await api.delete(`/mitarbeiter/${id}/2fa`);
    return response.data;
  },

  forcePasswordReset: async (id: number) => {
    const response = await api.post(`/mitarbeiter/${id}/force-password-reset`);
    return response.data;
  },
};
